import { render, staticRenderFns } from "./ChatQueuePanel.vue?vue&type=template&id=ef24e4aa&scoped=true"
import script from "./ChatQueuePanel.vue?vue&type=script&lang=js"
export * from "./ChatQueuePanel.vue?vue&type=script&lang=js"
import style0 from "./ChatQueuePanel.vue?vue&type=style&index=0&id=ef24e4aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef24e4aa",
  null
  
)

export default component.exports